export class JobFinderLayout {

  _jobFinderWrapperEl;
  _jobsElements;
  _jobsListWrapperEl;
  _jobsNotFoundEl;
  _jobs;
  _searchButton;
  _searchInput;
  _citySelect;
  _departmentSelect;

  init() {
    this._jobFinderWrapperEl = document.querySelector('.job-finder-wrapper');

    if (this._jobFinderWrapperEl) {
      this.afterPageRender();
    }
  }

  afterPageRender() {
    this._jobsListWrapperEl = this._jobFinderWrapperEl.querySelector('.job-finder-wrapper__container__jobs-list');

    if (this._jobsListWrapperEl) {
      this._searchButton = this._jobFinderWrapperEl.querySelector('.search-button');
      this._searchInput = this._jobFinderWrapperEl.querySelector('input[type="search"]');
      this._citySelect = this._jobFinderWrapperEl.querySelector('select[name="city-select"]');
      this._departmentSelect = this._jobFinderWrapperEl.querySelector('select[name="department-select"]');
      this._jobsElements = Array.from(this._jobsListWrapperEl.querySelectorAll('.job'));
      this._jobsNotFoundEl = this._jobFinderWrapperEl.querySelector('.job-finder-wrapper__container__no-results');

      if ( this._jobsElements.length ) {
        this._jobsNotFoundEl.classList.replace('d-flex', 'd-none');
      }

      this._jobs = this._jobsElements.map(x => {
        return {
          el: x,
          ...x.dataset
        };
      });

      this.searchActions();
    } else {
      console.log('cv actions')
    }
  }

  searchActions() {
    this.setSelectOptions('city', this._citySelect);
    this.setSelectOptions('department', this._departmentSelect);

    this._searchButton.addEventListener('click', () => {
      if (
         this._citySelect.value === 'none' &&
         this._departmentSelect.value === 'none' &&
         !this._searchInput.value.trim().length
       ) {
        this._jobs.forEach(x => x.el.classList.remove('d-none' ));
        this._jobsNotFoundEl.classList.replace('d-flex', 'd-none');
        return;
      }

      this._jobs.forEach(x => {
        if (
          (
            x.city.includes(this._citySelect.value) || this._citySelect.value === 'none'
          ) &&
          (
            x.department.includes(this._departmentSelect.value) || this._departmentSelect.value === 'none'
          ) &&
          (
            !this._searchInput.value.trim().length ||
            (
              x.tags.trim().toLowerCase().split(',').indexOf(this._searchInput.value.toLowerCase()) > -1 ||
              x.position.trim().toLowerCase().indexOf(this._searchInput.value.toLowerCase()) > -1
            )
          )
      ) {
        x.el.classList.remove('d-none');
        this._jobsNotFoundEl.classList.replace('d-flex', 'd-none')
      } else {
        x.el.classList.add('d-none');

        if ( this._jobs.every(x => x.el.classList.contains('d-none')) ) {
          this._jobsNotFoundEl.classList.replace('d-none', 'd-flex');
        }
       }
      });
    });
  }

  setSelectOptions(key, select) {
    [...new Set(this._jobs.map(x => x[key]))].forEach(el => select.innerHTML += `<option value="${ el }">${ el }</option>`);
  }
}
